import { COLORTYPES } from "../../../utils/colors";

export const FILEEDITORTYPES = {
  STICKER: 1,
  CUTTINGPLOTT: 2,
  PERFORATED: 3,
  FLOORPRINT: 4,
  ADHESION: 5,
  TEXTEDITOR: 6,
  MAGNETIC: 7,
  PHOTOWALLPAPER: 8,
  CANVAS: 9,
  FROSTED: 10,
  ALUSIGN: 11,
  SEALLABEL: 12,
  POSTER: 13,
  PVCSIGN: 14,
  BANNERPVC: 15,
  BANNERMESH: 16,
  ROLLUP: 17,
  STICKER_RECTANGULAR: 18,
  STICKER_CUT: 19,
  STICKER_CIRCLE: 20,
  STICKER_PREMIUM: 21,
  BLANK_FILM_CUT: 22,
  STICKER_DOTTED: 23,
  STICKER_STRONG: 24,
  STICKER_CARAVAN: 25,
  FLOORPRINT_ECO: 26,
  STICKER_WHITEPRINT: 27,
  STICKER_PVC_FREE: 28,
};

export const FILEEDITORTYPENAMES = {
  1: "STICKER",
  2: "CUTTINGPLOTT",
  3: "PERFORATED",
  4: "FLOORPRINT",
  5: "ADHESION",
  6: "TEXTEDITOR",
  7: "MAGNETIC",
  8: "PHOTOWALLPAPER",
  9: "CANVAS",
  10: "FROSTED",
  11: "ALUSIGN",
  12: "SEALLABEL",
  13: "POSTER",
  14: "PVCSIGN",
  15: "BANNERPVC",
  16: "BANNERMESH",
  17: "ROLLUP",
  18: "STICKER_RECTANGULAR",
  19: "STICKER_CUT",
  20: "STICKER_CIRCLE",
  21: "STICKER_PREMIUM",
  22: "BLANK_FILM_CUT",
  23: "STICKER_DOTTED",
  24: "STICKER_STRONG",
  25: "STICKER_CARAVAN",
  26: "FLOORPRINT_ECO",
  27: "STICKER_WHITEPRINT",
  28: "STICKER_PVC_FREE",
};

export const FILEEDITOR = {};
FILEEDITOR[FILEEDITORTYPES.STICKER] = {
  icon: "https://cdn.myfolie.de/media/products/klebefolie_standard-min.png",
  basicAmount: 0.1,
  surfacePenaltyMinSize: 0.09,
  maxSurfaceDiscount: 0.35,
  minPrice: 3.185,
  pricePerSqm: 25,
  variantId: 1790, // from shop
  boundaries: {
    minWidth: 10,
    maxWidth: 50000,
    minHeight: 10,
    maxHeight: 50000,
    maxNoDevide: 1510,
  },
  surchargeUnderglass: {
    fix: 0,
    percentage: 30,
  },
  sections: [
    "size",
    "laminate",
    "cutting",
    "underglass",
    "border",
    "filecheck",
  ],
  laminates: [
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "matt",
      iconURL: "https://cdn.myfolie.de/media/editor/mat.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "glossy",
      iconURL: "https://cdn.myfolie.de/media/editor/glossy.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "none",
      iconURL: "https://cdn.myfolie.de/media/editor/none.png",
    },
  ],
  cuttings: [
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "rectangular",
      // iconURL: require('theme/images/icons/cutting-rectangular.svg')
    },
    {
      surcharge: {
        fix: 2.5,
        percentage: 20,
      },
      key: "outline",
      // iconURL: require('theme/images/icons/cutting-contour.svg')
    },
    {
      surcharge: {
        fix: 12,
        percentage: 25,
      },
      key: "exempted",
      // iconURL: require('theme/images/icons/cutting-extempted.svg')
    },
  ],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.STICKER_PVC_FREE] = {
  icon: "https://cdn.myfolie.de/media/pvc_free.jpeg",
  basicAmount: 0.1,
  surfacePenaltyMinSize: 0.09,
  maxSurfaceDiscount: 0.35,
  minPrice: 3.185,
  pricePerSqm: 30,
  variantId: 27674, // from shop
  boundaries: {
    minWidth: 10,
    maxWidth: 50000,
    minHeight: 10,
    maxHeight: 50000,
    maxNoDevide: 1510,
  },
  sections: ["size", "laminate", "cutting", "border", "filecheck"],
  laminates: [
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "glossy",
      iconURL: "https://cdn.myfolie.de/media/editor/glossy.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "none",
      iconURL: "https://cdn.myfolie.de/media/editor/none.png",
    },
  ],
  cuttings: [
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "rectangular",
      // iconURL: require('theme/images/icons/cutting-rectangular.svg')
    },
    {
      surcharge: {
        fix: 2.5,
        percentage: 20,
      },
      key: "outline",
      // iconURL: require('theme/images/icons/cutting-contour.svg')
    },
    {
      surcharge: {
        fix: 12,
        percentage: 25,
      },
      key: "exempted",
      // iconURL: require('theme/images/icons/cutting-extempted.svg')
    },
  ],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.STICKER_PREMIUM] = {
  icon: "https://cdn.myfolie.de/media/products/klebefolie_premium-min.png",
  basicAmount: 0.1,
  surfacePenaltyMinSize: 0.09,
  minPrice: 5.03,
  pricePerSqm: 33,
  maxSurfaceDiscount: 0.35,
  variantId: 1791, // from shop
  boundaries: {
    minWidth: 10,
    maxWidth: 50000,
    minHeight: 10,
    maxHeight: 50000,
    maxNoDevide: 1510,
  },
  surchargeUnderglass: {
    fix: 0,
    percentage: 30,
  },
  sections: [
    "size",
    "laminate",
    "cutting",
    "underglass",
    "border",
    "filecheck",
  ],
  laminates: [
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "matt",
      iconURL: "https://cdn.myfolie.de/media/editor/mat.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "glossy",
      iconURL: "https://cdn.myfolie.de/media/editor/glossy.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "none",
      iconURL: "https://cdn.myfolie.de/media/editor/none.png",
    },
  ],
  cuttings: [
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "rectangular",
      // iconURL: require('theme/images/icons/cutting-rectangular.svg')
    },
    {
      surcharge: {
        fix: 2.5,
        percentage: 20,
      },
      key: "outline",
      // iconURL: require('theme/images/icons/cutting-contour.svg')
    },
    {
      surcharge: {
        fix: 12,
        percentage: 25,
      },
      key: "exempted",
      // iconURL: require('theme/images/icons/cutting-extempted.svg')
    },
  ],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.STICKER_WHITEPRINT] = {
  icon: "https://cdn.myfolie.de/media/products/whiteprint_adhesive_min.png",
  basicAmount: 0.1,
  surfacePenaltyMinSize: 0.09,
  minPrice: 5.03,
  pricePerSqm: 33,
  maxSurfaceDiscount: 0.35,
  variantId: 26825, // from shop
  boundaries: {
    minWidth: 10,
    maxWidth: 50000,
    minHeight: 10,
    maxHeight: 50000,
  },
  surchargeUnderglass: {
    fix: 0,
    percentage: 0,
  },
  sections: [
    "size",
    "cutting",
    "whiteprint_mode",
    "underglass",
    "border",
    "filecheck",
  ],
  cuttings: [
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "rectangular",
      // iconURL: require('theme/images/icons/cutting-rectangular.svg')
    },
    {
      surcharge: {
        fix: 2.5,
        percentage: 20,
      },
      key: "outline",
      // iconURL: require('theme/images/icons/cutting-contour.svg')
    },
  ],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.STICKER_CARAVAN] = {
  icon: "https://cdn.myfolie.de/media/products/klebefolie_caravan-min.png",
  basicAmount: 0.1,
  surfacePenaltyMinSize: 0.09,
  minPrice: 5.03,
  pricePerSqm: 37.5,
  maxSurfaceDiscount: 0.35,
  variantId: 14808, // from shop
  boundaries: {
    minWidth: 10,
    maxWidth: 50000,
    minHeight: 10,
    maxHeight: 50000,
  },
  sections: ["size", "laminate", "cutting", "border", "filecheck"],
  laminates: [
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "matt",
      iconURL: "https://cdn.myfolie.de/media/editor/mat.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "glossy",
      iconURL: "https://cdn.myfolie.de/media/editor/glossy.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "none",
      iconURL: "https://cdn.myfolie.de/media/editor/none.png",
    },
  ],
  cuttings: [
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "rectangular",
      // iconURL: require('theme/images/icons/cutting-rectangular.svg')
    },
    {
      surcharge: {
        fix: 2.5,
        percentage: 20,
      },
      key: "outline",
      // iconURL: require('theme/images/icons/cutting-contour.svg')
    },
    {
      surcharge: {
        fix: 12,
        percentage: 25,
      },
      key: "exempted",
      // iconURL: require('theme/images/icons/cutting-extempted.svg')
    },
  ],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.STICKER_STRONG] = {
  icon: "https://cdn.myfolie.de/media/products/stark_haftend-min.png",
  basicAmount: 0.1,
  surfacePenaltyMinSize: 0.09,
  minPrice: 5.03,
  pricePerSqm: 33,
  maxSurfaceDiscount: 0.35,
  variantId: 1792, // from shop
  boundaries: {
    minWidth: 10,
    maxWidth: 50000,
    minHeight: 10,
    maxHeight: 50000,
    maxNoDevide: 1270,
  },
  sections: ["size", "laminate", "cutting", "border", "filecheck"],
  laminates: [
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "matt",
      iconURL: "https://cdn.myfolie.de/media/editor/mat.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "glossy",
      iconURL: "https://cdn.myfolie.de/media/editor/glossy.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "none",
      iconURL: "https://cdn.myfolie.de/media/editor/none.png",
    },
  ],
  cuttings: [
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "rectangular",
      // iconURL: require('theme/images/icons/cutting-rectangular.svg')
    },
    {
      surcharge: {
        fix: 2.5,
        percentage: 20,
      },
      key: "outline",
      // iconURL: require('theme/images/icons/cutting-contour.svg')
    },
    {
      surcharge: {
        fix: 12,
        percentage: 25,
      },
      key: "exempted",
      // iconURL: require('theme/images/icons/cutting-extempted.svg')
    },
  ],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.STICKER_DOTTED] = {
  icon: "https://cdn.myfolie.de/media/products/klebefolie_easydot-min.png",
  basicAmount: 0.1,
  surfacePenaltyMinSize: 0.09,
  minPrice: 5.03,
  pricePerSqm: 33,
  maxSurfaceDiscount: 0.35,
  variantId: 1793, // from shop
  boundaries: {
    minWidth: 10,
    maxWidth: 50000,
    minHeight: 10,
    maxHeight: 50000,
  },
  sections: ["size", "laminate", "cutting", "border", "filecheck"],
  laminates: [
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "matt",
      iconURL: "https://cdn.myfolie.de/media/editor/mat.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "glossy",
      iconURL: "https://cdn.myfolie.de/media/editor/glossy.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "none",
      iconURL: "https://cdn.myfolie.de/media/editor/none.png",
    },
  ],
  cuttings: [
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "rectangular",
      // iconURL: require('theme/images/icons/cutting-rectangular.svg')
    },
    {
      surcharge: {
        fix: 2.5,
        percentage: 20,
      },
      key: "outline",
      // iconURL: require('theme/images/icons/cutting-contour.svg')
    },
    {
      surcharge: {
        fix: 12,
        percentage: 25,
      },
      key: "exempted",
      // iconURL: require('theme/images/icons/cutting-extempted.svg')
    },
  ],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.FROSTED] = {
  icon: "https://cdn.myfolie.de/media/products/klebefolie-milchglas.png",
  basicAmount: 0.1,
  surfacePenaltyMinSize: 0.09,
  minPrice: 5.03,
  pricePerSqm: 40,
  maxSurfaceDiscount: 0.35,
  variantId: 1794, // from shop
  sections: ["size", "cutting", "filecheck"],
  cuttings: [
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "rectangular",
      // iconURL: require('theme/images/icons/cutting-rectangular.svg')
    },
    {
      surcharge: {
        fix: 2.5,
        percentage: 20,
      },
      key: "outline",
      // iconURL: require('theme/images/icons/cutting-contour.svg')
    },
    {
      surcharge: {
        fix: 12,
        percentage: 25,
      },
      key: "exempted",
      // iconURL: require('theme/images/icons/cutting-extempted.svg')
    },
  ],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.CUTTINGPLOTT] = {
  icon: "https://cdn.myfolie.de/media/products/schneideplott-min.png",
  basicAmount: 5,
  pricePerSqm: 45,
  surfacePenaltyMinSize: 0.09,
  minPrice: 6.71,
  variantId: 1795, // from shop
  forceCutting: "exempted",
  surchargeUnderglass: {
    fix: 0,
    percentage: 0,
  },
  colors: [
    COLORTYPES.GLOSSY,
    COLORTYPES.MATT,
    COLORTYPES.NEON,
    COLORTYPES.FROSTED,
  ],
  sections: ["size", "vinyl", "color", "underglass", "filecheck"],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.PERFORATED] = {
  icon: "https://cdn.myfolie.de/media/products/lochfolie-min.png",
  basicAmount: 0.1,
  surfacePenaltyMinSize: 0.09,
  minPrice: 5.87,
  pricePerSqm: 60,
  maxSurfaceDiscount: 0.35,
  variantId: 1796, // from shop
  forceCutting: "rectangular",
  boundaries: {
    maxNoDevide: 1510,
  },
  surchargeUnderglass: {
    fix: 0,
    percentage: 0,
  },
  sections: ["size", "border", "filecheck"],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.MAGNETIC] = {
  icon: "https://cdn.myfolie.de/media/products/magnetfolie-min.png",
  basicAmount: 5,
  surfacePenaltyMinSize: 0.09,
  minPrice: 16.63,
  pricePerSqm: 50,
  maxSurfaceDiscount: 0.25,
  variantId: 1797, // from shop
  forceCutting: "rectangular",
  boundaries: {
    maxNoDevide: 1000,
  },
  surchargeUnderglass: {
    fix: 0,
    percentage: 0,
  },
  laminates: [
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "matt",
      iconURL: "https://cdn.myfolie.de/media/editor/mat.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "glossy",
      iconURL: "https://cdn.myfolie.de/media/editor/glossy.png",
    },
  ],
  sections: ["size", "laminate", "filecheck"],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.FLOORPRINT] = {
  icon: "https://cdn.myfolie.de/media/products/bodenfolie-min.png",
  basicAmount: 0.1,
  surfacePenaltyMinSize: 0.09,
  minPrice: 8.31,
  pricePerSqm: 40,
  maxSurfaceDiscount: 0.35,
  variantId: 1798, // from shop
  boundaries: {
    maxNoDevide: 1290,
  },
  sections: ["size", "laminate", "cutting", "border", "filecheck"],
  laminates: [
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "matt",
      iconURL: "https://cdn.myfolie.de/media/editor/mat.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "glossy",
      iconURL: "https://cdn.myfolie.de/media/editor/glossy.png",
    },
  ],
  cuttings: [
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "rectangular",
      // iconURL: require('theme/images/icons/cutting-rectangular.svg')
    },
    {
      surcharge: {
        fix: 2.5,
        percentage: 20,
      },
      key: "outline",
      // iconURL: require('theme/images/icons/cutting-contour.svg')
    },
  ],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.FLOORPRINT_ECO] = {
  icon: "https://cdn.myfolie.de/media/products/bodenfolie-min.png",
  basicAmount: 3,
  surfacePenaltyMinSize: 0.09,
  minPrice: 7.555,
  pricePerSqm: 33,
  maxSurfaceDiscount: 0.35,
  variantId: 22167, // from shop
  boundaries: {
    maxNoDevide: 1290,
  },
  surchargeUnderglass: {
    fix: 0,
    percentage: 0,
  },
  sections: ["size", "cutting", "border", "filecheck"],
  cuttings: [
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "rectangular",
      // iconURL: require('theme/images/icons/cutting-rectangular.svg')
    },
    {
      surcharge: {
        fix: 2.5,
        percentage: 20,
      },
      key: "outline",
      // iconURL: require('theme/images/icons/cutting-contour.svg')
    },
  ],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.ADHESION] = {
  icon: "https://cdn.myfolie.de/media/products/statische_folie-min.png",
  basicAmount: 0.1,
  surfacePenaltyMinSize: 0.09,
  minPrice: 5.03,
  pricePerSqm: 39,
  maxSurfaceDiscount: 0.35,
  variantId: 1799, // from shop
  surchargeUnderglass: {
    fix: 0,
    percentage: 0,
  },
  boundaries: {
    maxNoDevide: 1360,
  },
  sections: ["size", "cutting", "border", "filecheck"],
  cuttings: [
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "rectangular",
      // iconURL: require('theme/images/icons/cutting-rectangular.svg')
    },
    {
      surcharge: {
        fix: 2.5,
        percentage: 20,
      },
      key: "outline",
      // iconURL: require('theme/images/icons/cutting-contour.svg')
    },
  ],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.PHOTOWALLPAPER] = {
  icon: "https://cdn.myfolie.de/media/products/fototapete.png",
  basicAmount: 9,
  warningSize: 1200,
  pricePerSqm: 18,
  maxSurfaceDiscount: 0.2,
  minPrice: 6.19,
  variantId: 1800, // from shop
  showMMWarning: true,
  surchargeUnderglass: {
    fix: 0,
    percentage: 0,
  },
  forceCutting: "rectangular",
  sections: ["size", "stripwidth", "filecheck"],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.CANVAS] = {
  icon: "https://cdn.myfolie.de/media/products/fotoleinwand.png",
  basicAmount: 9,
  pricePerSqm: 42,
  roundPrice: true,
  maxSurfaceDiscount: 0.01,
  variantId: 1801, // from shop
  surchargeUnderglass: {
    fix: 0,
    percentage: 0,
  },
  sections: ["sizeselect", "filecheck"],
  forceCutting: "rectangular",
  availableSizes: [
    {
      title: "topseller",
      sizes: [
        [300, 300],
        [400, 300],
        [400, 600],
        [600, 400],
        [900, 300],
        [900, 600],
      ],
    },
    {
      title: "square",
      sizes: [
        [300, 300],
        [400, 400],
        [500, 500],
        [600, 600],
        [700, 700],
        [800, 800],
        [900, 900],
        [1000, 1000],
        [1200, 1200],
      ],
    },
    {
      title: "4:3",
      sizes: [
        [400, 300],
        [800, 600],
        [1200, 800],
      ],
    },
    {
      title: "3:2",
      sizes: [
        [600, 400],
        [900, 600],
        [1200, 800],
      ],
    },
    {
      title: "portrait",
      sizes: [
        [400, 500],
        [400, 600],
        [400, 700],
        [400, 800],
        [400, 900],
        [400, 1000],
        [400, 1200],
      ],
    },
    {
      title: "2:1",
      sizes: [
        [600, 300],
        [800, 400],
        [1000, 500],
        [1200, 600],
      ],
    },
    {
      title: "5:2",
      sizes: [[1000, 400]],
    },
    {
      title: "3:1",
      sizes: [
        [900, 300],
        [1200, 400],
      ],
    },
  ],
  discounts: [
    { amount: 2, percentage: 10 },
    { amount: 3, percentage: 10 },
    { amount: 4, percentage: 10 },
    { amount: 5, percentage: 15 },
    { amount: 10, percentage: 20 },
    { amount: 15, percentage: 20 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.PVCSIGN] = {
  icon: "https://cdn.myfolie.de/media/products/pvcschild.png",
  basicAmount: 9,
  pricePerSqm: 45,
  variantId: 1802, // from shop
  showMMWarning: true,
  forceCutting: "rectangular",
  sections: ["sizeselect", "filecheck"],
  availableThickness: [
    {
      mm: 2,
      surcharge: {
        fix: 0,
        percentage: 5,
      },
    },
    {
      mm: 3,
      surcharge: {
        fix: 0,
        percentage: 10,
      },
    },
    {
      mm: 4,
      surcharge: {
        fix: 0,
        percentage: 12,
      },
    },
    {
      mm: 5,
      surcharge: {
        fix: 0,
        percentage: 15,
      },
    },
  ],
  availableSizes: [
    {
      title: "topseller",
      sizes: [
        [200, 200],
        [500, 500],
        [750, 500],
        [1000, 700],
      ],
    },
    {
      title: "square",
      sizes: [
        [200, 200],
        [500, 500],
      ],
    },
    {
      title: "4:3",
      sizes: [
        [400, 300],
        [800, 600],
      ],
    },
    {
      title: "3:2",
      sizes: [
        [300, 200],
        [600, 400],
        [450, 300],
        [750, 500],
        [900, 600],
      ],
    },
  ],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.ALUSIGN] = {
  icon: "https://cdn.myfolie.de/media/products/aluschild.png",
  basicAmount: 9,
  pricePerSqm: 42,
  variantId: 1803, // from shop
  showMMWarning: true,
  sections: ["sizeselect", "filecheck"],
  forceCutting: "rectangular",
  availableThickness: [
    {
      mm: 2,
      surcharge: {
        fix: 0,
        percentage: 5,
      },
    },
    {
      mm: 3,
      surcharge: {
        fix: 0,
        percentage: 10,
      },
    },
    {
      mm: 4,
      surcharge: {
        fix: 0,
        percentage: 12,
      },
    },
    {
      mm: 5,
      surcharge: {
        fix: 0,
        percentage: 15,
      },
    },
  ],
  availableSizes: [
    {
      title: "topseller",
      sizes: [
        [200, 200],
        [500, 500],
        [750, 500],
        [1000, 700],
      ],
    },
    {
      title: "square",
      sizes: [
        [200, 200],
        [500, 500],
      ],
    },
    {
      title: "4:3",
      sizes: [
        [400, 300],
        [800, 600],
      ],
    },
    {
      title: "3:2",
      sizes: [
        [300, 200],
        [600, 400],
        [450, 300],
        [750, 500],
        [900, 600],
      ],
    },
  ],
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.SEALLABEL] = {
  basicAmount: 9,
  pricePerSqm: 42,
  variantId: 1804, // from shop
  surchargeUnderglass: {
    fix: 0,
    percentage: 0,
  },
  sections: ["size", "filecheck"],
  forceCutting: "rectangular",
  discounts: [
    { amount: 2, percentage: 10 },
    { amount: 5, percentage: 15 },
    { amount: 10, percentage: 20 },
    { amount: 20, percentage: 30 },
    { amount: 30, percentage: 40 },
    { amount: 50, percentage: 50 },
    { amount: 100, percentage: 60 },
    { amount: 250, percentage: 70 },
    { amount: 500, percentage: 77 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.POSTER] = {
  icon: "https://cdn.myfolie.de/media/products/fotoposter.png",
  basicAmount: 1,
  pricePerSqm: 20,
  maxSurfaceDiscount: 0.01,
  minPrice: 2.99,
  variantId: 1805, // from shop
  showMMWarning: true,
  sections: ["size", "filecheck"],
  forceCutting: "rectangular",
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.BANNERMESH] = {
  icon: "https://cdn.myfolie.de/media/products/pvc-mesh-small.png",
  basicAmount: 7,
  pricePerSqm: 20,
  warningSize: 400,
  minPrice: 6.19,
  variantId: 1806, // from shop
  showMMWarning: true,
  boundaries: {
    maxNoDevide: 1560,
  },
  sections: [
    "size",
    // 'eyelet',
    "filecheck",
  ],
  forceCutting: "rectangular",
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.BANNERPVC] = {
  icon: "https://cdn.myfolie.de/media/products/pvc_banner-min.png",
  basicAmount: 7,
  pricePerSqm: 20,
  warningSize: 400,
  minPrice: 6.19,
  variantId: 1807, // from shop
  showMMWarning: true,
  boundaries: {
    maxNoDevide: 1560,
  },
  sections: [
    "size",
    // 'eyelet',
    "filecheck",
  ],
  forceCutting: "rectangular",
  discounts: [
    { amount: 2, percentage: 5 },
    { amount: 5, percentage: 8 },
    { amount: 10, percentage: 10 },
    { amount: 20, percentage: 15 },
    { amount: 30, percentage: 17 },
    { amount: 50, percentage: 20 },
    { amount: 100, percentage: 23 },
    { amount: 250, percentage: 25 },
    { amount: 500, percentage: 27 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.ROLLUP] = {
  basicAmount: 29,
  pricePerSqm: 20,
  forceCutting: "rectangular",
  variantId: 1808, // from shop
  surchargeUnderglass: {
    fix: 0,
    percentage: 0,
  },
  availableSizes: [
    {
      title: "topseller",
      sizes: [[700, 1800]],
    },
  ],
  sections: ["sizeselect", "filecheck"],
  discounts: [
    { amount: 2, percentage: 10 },
    { amount: 5, percentage: 12 },
    { amount: 10, percentage: 15 },
    { amount: 20, percentage: 20 },
    { amount: 30, percentage: 25 },
  ],
};

// FIXME DUMMY OBJECT FOR PRICE CALCULATION
// this should be in a different file, we need maybe a more abstract editor type to distinguish between general layouts
FILEEDITOR[FILEEDITORTYPES.TEXTEDITOR] = {
  basicAmount: 5.92,
  pricePerSqm: 49,
  variantId: 1, // from shop
  surchargeUnderglass: {
    fix: 0,
    percentage: 0,
  },
  colors: [
    // FIXME not used currently
    COLORTYPES.GLOSSY,
    COLORTYPES.MATT,
    COLORTYPES.NEON,
    COLORTYPES.FROSTED,
  ],
  sections: ["size", "vinyl", "color", "underglass", "lines"],
  discounts: [
    { amount: 2, percentage: 10 },
    { amount: 5, percentage: 15 },
    { amount: 10, percentage: 20 },
    { amount: 20, percentage: 30 },
    { amount: 30, percentage: 40 },
    { amount: 50, percentage: 50 },
    { amount: 100, percentage: 60 },
    { amount: 250, percentage: 70 },
    { amount: 500, percentage: 77 },
  ],
};

// FIXME DUMMY OBJECT FOR PRICE CALCULATION
// this should be in a different file, we need maybe a more abstract editor type to distinguish between general layouts
FILEEDITOR[FILEEDITORTYPES.BLANK_FILM_CUT] = {
  basicAmount: 5.92,
  pricePerSqm: 49,
  variantId: 1809, // from shop
  surchargeUnderglass: {
    fix: 0,
    percentage: 0,
  },
  colors: [
    // FIXME not used currently
    COLORTYPES.GLOSSY,
    COLORTYPES.MATT,
    COLORTYPES.NEON,
    COLORTYPES.FROSTED,
  ],
  sections: ["size", "vinyl", "color", "underglass", "lines"],
  discounts: [{ amount: 2, percentage: 10 }],
};

FILEEDITOR[FILEEDITORTYPES.STICKER_RECTANGULAR] = {
  icon: "https://cdn.myfolie.de/media/products/sticker-rectangular.png",
  basicAmount: 0.25,
  warningSize: 20,
  surfacePenaltyMinSize: 0.09,
  pricePerSqm: 12,
  variantId: 1810, // from shop
  boundaries: {
    minWidth: 5,
    maxWidth: 300,
    minHeight: 5,
    maxHeight: 300,
  },
  forceCutting: "rectangular",
  sections: ["sizeselect", "laminate"],
  laminates: [
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "matt",
      iconURL: "https://cdn.myfolie.de/media/editor/mat.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "glossy",
      iconURL: "https://cdn.myfolie.de/media/editor/glossy.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "none",
      iconURL: "https://cdn.myfolie.de/media/editor/none.png",
    },
  ],
  cuttings: [
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "rectangular",
      // iconURL: require('theme/images/icons/cutting-rectangular.svg')
    },
  ],
  availableSizes: [
    {
      title: "topseller",
      sizes: [
        [50, 25],
        [50, 50],
        [75, 50],
        [75, 75],
        [100, 50],
        [100, 100],
        [125, 50],
        [125, 75],
        [150, 75],
      ],
    },
    {
      title: "square",
      sizes: [
        [25, 25],
        [50, 50],
        [75, 75],
        [100, 100],
        [125, 125],
        [150, 150],
        [175, 175],
        [200, 200],
      ],
    },
    {
      title: "4:3",
      sizes: [
        [40, 30],
        [80, 60],
        [100, 75],
        [120, 80],
        [140, 105],
      ],
    },
    {
      title: "3:2",
      sizes: [
        [60, 40],
        [90, 60],
        [120, 80],
      ],
    },
    {
      title: "2:1",
      sizes: [
        [50, 25],
        [60, 30],
        [80, 40],
        [100, 50],
        [120, 60],
        [150, 75],
      ],
    },
    {
      title: "5:2",
      sizes: [
        [50, 20],
        [75, 40],
        [100, 40],
        [125, 50],
      ],
    },
    {
      title: "3:1",
      sizes: [
        [90, 30],
        [120, 40],
        [150, 50],
      ],
    },
  ],
  enableCustomSizes: true,
  showDefaultAmounts: true,
  discounts: [
    { amount: 50, percentage: 0 },
    { amount: 100, percentage: 30 },
    { amount: 200, percentage: 49 },
    { amount: 300, percentage: 56 },
    { amount: 500, percentage: 63 },
    { amount: 1000, percentage: 66 },
    { amount: 2000, percentage: 69 },
    { amount: 3000, percentage: 72 },
    { amount: 5000, percentage: 74 },
    { amount: 10000, percentage: 76 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.STICKER_CIRCLE] = {
  icon: "https://cdn.myfolie.de/media/products/sticker-circle.png",
  basicAmount: 0.25,
  warningSize: 20,
  surfacePenaltyMinSize: 0.09,
  pricePerSqm: 12,
  variantId: 1811, // from shop
  cropShape: "round",
  boundaries: {
    minWidth: 5,
    maxWidth: 300,
    minHeight: 5,
    maxHeight: 300,
  },
  sections: ["sizeselect", "laminate"],
  laminates: [
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "matt",
      iconURL: "https://cdn.myfolie.de/media/editor/mat.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "glossy",
      iconURL: "https://cdn.myfolie.de/media/editor/glossy.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "none",
      iconURL: "https://cdn.myfolie.de/media/editor/none.png",
    },
  ],
  cuttings: [
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "exempted",
      // iconURL: require('theme/images/icons/cutting-extempted.svg')
    },
  ],
  availableSizes: [
    {
      title: "circle",
      sizes: [
        [25, 25],
        [35, 35],
        [50, 50],
        [75, 75],
        [90, 90],
        [100, 100],
        [125, 125],
        [150, 150],
      ],
    },
  ],
  enableCustomSizes: true,
  showDefaultAmounts: true,
  discounts: [
    { amount: 50, percentage: 0 },
    { amount: 100, percentage: 30 },
    { amount: 200, percentage: 49 },
    { amount: 300, percentage: 56 },
    { amount: 500, percentage: 63 },
    { amount: 1000, percentage: 66 },
    { amount: 2000, percentage: 69 },
    { amount: 3000, percentage: 72 },
    { amount: 5000, percentage: 74 },
    { amount: 10000, percentage: 76 },
  ],
};

FILEEDITOR[FILEEDITORTYPES.STICKER_CUT] = {
  icon: "https://cdn.myfolie.de/media/products/sticker-diecut.png",
  basicAmount: 0.35,
  warningSize: 20,
  surfacePenaltyMinSize: 0.09,
  pricePerSqm: 15,
  variantId: 1812, // from shop
  boundaries: {
    minWidth: 5,
    maxWidth: 300,
    minHeight: 5,
    maxHeight: 300,
  },
  sections: ["sizeselect", "laminate"],
  laminates: [
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "matt",
      iconURL: "https://cdn.myfolie.de/media/editor/mat.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 10,
      },
      key: "glossy",
      iconURL: "https://cdn.myfolie.de/media/editor/glossy.png",
    },
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "none",
      iconURL: "https://cdn.myfolie.de/media/editor/none.png",
    },
  ],
  cuttings: [
    {
      surcharge: {
        fix: 0,
        percentage: 0,
      },
      key: "exempted",
      // iconURL: require('theme/images/icons/cutting-extempted.svg')
    },
  ],
  availableSizes: [
    {
      title: "topseller",
      sizes: [
        [50, 25],
        [50, 50],
        [75, 50],
        [75, 75],
        [100, 50],
        [100, 100],
        [125, 50],
        [125, 75],
        [150, 75],
      ],
    },
    {
      title: "square",
      sizes: [
        [25, 25],
        [50, 50],
        [75, 75],
        [100, 100],
        [125, 125],
        [150, 150],
        [175, 175],
        [200, 200],
      ],
    },
    {
      title: "4:3",
      sizes: [
        [40, 30],
        [80, 60],
        [100, 75],
        [120, 80],
        [140, 105],
      ],
    },
    {
      title: "3:2",
      sizes: [
        [60, 40],
        [90, 60],
        [120, 80],
      ],
    },
    {
      title: "2:1",
      sizes: [
        [50, 25],
        [60, 30],
        [80, 40],
        [100, 50],
        [120, 60],
        [150, 75],
      ],
    },
    {
      title: "5:2",
      sizes: [
        [50, 20],
        [75, 40],
        [100, 40],
        [125, 50],
      ],
    },
    {
      title: "3:1",
      sizes: [
        [90, 30],
        [120, 40],
        [150, 50],
      ],
    },
  ],
  enableCustomSizes: true,
  showDefaultAmounts: true,
  discounts: [
    { amount: 50, percentage: 0 },
    { amount: 100, percentage: 30 },
    { amount: 200, percentage: 49 },
    { amount: 300, percentage: 56 },
    { amount: 500, percentage: 63 },
    { amount: 1000, percentage: 66 },
    { amount: 2000, percentage: 69 },
    { amount: 3000, percentage: 72 },
    { amount: 5000, percentage: 74 },
    { amount: 10000, percentage: 76 },
  ],
};
